import { useState, useEffect } from "react";

import useViewportDimensions from "src/hooks/viewport/useViewportDimensions";
import { getModulesContainerWidth } from "../utils";

/**
 * Hook responsible for returning width of nav container, which is wrapping
 * module names in navigation. This width is computed without width of arrows responsible for
 * moving forward and backward between modules in navigation;
 */
const useNavModulesContainerWidth = (): number => {
  const [containerWidth, setContainerWidth] = useState(0);
  const { x } = useViewportDimensions();

  useEffect(() => {
    const finalWidth = getModulesContainerWidth(x);

    setContainerWidth(finalWidth);
  }, [x]);

  return containerWidth;
};

export default useNavModulesContainerWidth;
